import {
  ErrorModal,
  HelmetDexteel,
  ShiftDayNavigatorControl,
  useShiftNavigator,
} from "@dexteel/mesf-core";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { StrandLossesManagerTable } from "./components/table/StrandLossesManagerTable";
import { useRealtimeInvalidation } from "./hooks/queries/useRealtimeInvalidation";
import { useStrandAssetsQuery } from "./hooks/queries/useStrandAssetsQuery";
import { useStrandLossesByShiftQuery } from "./hooks/queries/useStrandLossesByShiftQuery";

const PAGE_TITLE = "Strand Losses Manager";

export const StrandLossesManagerPage = () => {
  const { shiftInfo, getShiftDataFromAPI } = useShiftNavigator();
  const { shiftId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [showMicrolosses, setShowMicrolosses] = useState(false);
  const strandLossIdParam = Number(searchParams.get("strandLossId")) || null;

  useEffect(() => {
    getShiftDataFromAPI(null, shiftId ? Number(shiftId) : 0);
  }, [shiftId]);

  useEffect(() => {
    if (shiftInfo?.CurrentShiftId) {
      if (strandLossIdParam)
        navigate(
          `/strand-losses-manager/${shiftInfo.CurrentShiftId}?strandLossId=${strandLossIdParam}`,
        );
      else navigate(`/strand-losses-manager/${shiftInfo.CurrentShiftId}`);
    }
  }, [navigate, shiftInfo?.CurrentShiftId, strandLossIdParam]);

  useRealtimeInvalidation();

  const { data: assetScope, isLoading: isLoadingAssets } = useStrandAssetsQuery(
    (queryError) => setError(queryError.message),
  );
  const { data: strandLosses = [], isLoading: isLoadingStrandLosses } =
    useStrandLossesByShiftQuery(
      shiftInfo?.CurrentShiftId ?? 0,
      showMicrolosses,
      (queryError) => setError(queryError.message),
    );

  return (
    <>
      <HelmetDexteel
        title={`${shiftInfo?.CurrentStart.toLocaleDateString()} - ${PAGE_TITLE}`}
      />
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {PAGE_TITLE}
          </Typography>
        </Grid>
        <Grid item md={12} xs={12}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Grid container alignItems="center">
              <Grid item sx={{ width: "fit-content" }}>
                <ShiftDayNavigatorControl
                  preventInit
                  withPaper={false}
                  margin="0"
                />
              </Grid>
              <Grid item sx={{ width: "fit-content", ml: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showMicrolosses}
                      color="primary"
                      onChange={(event) =>
                        setShowMicrolosses(event.target.checked)
                      }
                    />
                  }
                  label="Microlosses"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <StrandLossesManagerTable
            isLoading={isLoadingAssets || isLoadingStrandLosses}
            strandLosses={strandLosses}
            parentAssetId={assetScope?.parentAssetId ?? null}
            strandAssets={assetScope?.strands ?? []}
            strandLossId={strandLossIdParam ?? undefined}
          />
        </Grid>
      </Grid>
      <ErrorModal
        error={error}
        onHide={() => setError("")}
        title="Strand Losses Manager error"
      />
    </>
  );
};
